import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsAlsoSearch.sss';

interface Props {
  className?: string,
}

export const ProductDetailsAlsoSearchSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Skeleton
        width='150px'
        height='24px'
      />

      <ul className={s.list}>
        {Array(6).fill(null).map((_, i) => (
          <li
            key={i}
            className={s.item}
          >
            <Skeleton
              width='100px'
              height='40px'
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
